import { createFileRoute, redirect } from '@tanstack/react-router'

import { api } from '@/lib/api/client'
import { supabase } from '@/lib/auth/client'

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    const { data } = await supabase.auth.getSession()
    if (!data.session) throw redirect({ to: '/login' })
    const res = await api.v1.profile.$get()
    if (res.status === 404) throw redirect({ to: '/onboarding' })
    throw redirect({ to: '/today' })
  },
  component: () => null,
})
